import React, { useContext, useEffect } from 'react';
import { Card, Button, Table, Sidebar, Segment, Menu, Icon, Popup } from 'semantic-ui-react';
import SiteVodafoneStore from '../../../app/stores/sitevodafoneStore';
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { Link } from 'react-router-dom';

interface DetailParams {
  id: string;
}

const SiteVodafoneDetails: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history
}) => {
  const sitevodafoneStore = useContext(SiteVodafoneStore);
  const {
    sitevodafone,
    loadSiteVodafone,
    loadSiteVodafoneHistory,
    sitevodafonehistoryByDate,
    selectHistory,
    loadingInitial
  } = sitevodafoneStore;

  useEffect(() => {
    loadSiteVodafone(match.params.id);
    loadSiteVodafoneHistory(match.params.id);
  }, [loadSiteVodafone, match.params.id]);

  const [visible, setVisible] = React.useState(false)

  if (loadingInitial || !sitevodafone) return <LoadingComponent content='Loading SiteVodafone ...' />

  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>&nbsp;&nbsp;Site ID:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {sitevodafone!.siteID_c}
          <Button
            floated='right'
            size='mini'
            content='View History'
            icon='history'
            onClick={() => setVisible(true)}
          />
        </Card.Header>
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            animation='overlay'
            icon='labeled'
            inverted
            direction='right'
            onHide={() => setVisible(false)}
            vertical
            visible={visible}
            width='thin'
          >
            {sitevodafonehistoryByDate.map(sitevodafonehistory => (
              <Popup
                trigger={<Menu.Item
                  as='a'
                  onClick={() => {
                    setVisible(false);
                    selectHistory(sitevodafonehistory.id);
                  }}
                >
                  <Icon name='file' />
                  <p> Modified By: {sitevodafonehistory.modifiedBy}</p>
                  <p> On: {sitevodafonehistory.updatedAt.substr(0,19).replace('T', ' ')} </p>
                </Menu.Item>}
              >
                <Popup.Content>
                  {sitevodafonehistory.remark}
                </Popup.Content>
              </Popup>
            ))}
          </Sidebar>

          <Sidebar.Pusher>
            <Table definition fixed>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={3} />
                  <Table.HeaderCell textAlign='center'>Description   </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>Site Name</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteName} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Updated Time</Table.Cell>
                  <Table.Cell> {sitevodafone!.updatedAt.substr(0,19).replace('T', ' ')} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Direct Access</Table.Cell>
                  <Table.Cell> {sitevodafone!.direct_Access} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Business Hours Site Access</Table.Cell>
                  <Table.Cell> {sitevodafone!.businessHoursSiteAccess} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >After Hours Site Access</Table.Cell>
                  <Table.Cell> {sitevodafone!.afterHoursSiteAccess} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Business Hours Emergency Site Access</Table.Cell>
                  <Table.Cell> {sitevodafone!.businessHoursEmergencySiteAccess} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >After Hours Emergency Site Access</Table.Cell>
                  <Table.Cell> {sitevodafone!.afterHoursEmergencySiteAccess} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site Type</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteType} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >FOPS Data</Table.Cell>
                  <Table.Cell> {sitevodafone!.fopsData} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Key Direct Access</Table.Cell>
                  <Table.Cell> {sitevodafone!.key_DirectAccess} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Comments</Table.Cell>
                  <Table.Cell> {sitevodafone!.comments} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Key Location Address</Table.Cell>
                  <Table.Cell> {sitevodafone!.keyLocationAddress} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Key Specific Details</Table.Cell>
                  <Table.Cell> {sitevodafone!.keySpecificDetails} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >OH_S Details</Table.Cell>
                  <Table.Cell> {sitevodafone!.oH_SDetails} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site Hazards</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteHazards} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site Induction Required</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteInductionRequired} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site Induction Contact Name</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteInductionContactName} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site Induction Contact Number</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteInductionContactNumber} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site Induction Contact Email</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteInductionContactEmail} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site Induction Details</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteInductionDetails} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site Induction Online Training</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteInductionOnlineTraining} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site Induction Online Training URL</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteInductionOnlineTrainingURL} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site Induction Validity Period</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteInductionValidityPeriod} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Structure Type</Table.Cell>
                  <Table.Cell> {sitevodafone!.structureType} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Special Details</Table.Cell>
                  <Table.Cell> {sitevodafone!.specialDetails} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Directions</Table.Cell>
                  <Table.Cell> {sitevodafone!.directions} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Address</Table.Cell>
                  <Table.Cell> 
                    {sitevodafone!.address} 
                    <Popup
                      content="Open in google map"
                      trigger={
                       <a href={`https://maps.google.com/?q=${sitevodafone.address}`} target="_Blank">
                       <Icon name='map marker alternate' size='large'/>
                       </a>
                      }
                    />
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Address Additional Info</Table.Cell>
                  <Table.Cell> {sitevodafone!.addressAdditional} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >City</Table.Cell>
                  <Table.Cell> {sitevodafone!.city} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >State Or Province</Table.Cell>
                  <Table.Cell> {sitevodafone!.stateOrProvince} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Postal Code</Table.Cell>
                  <Table.Cell> {sitevodafone!.postalCode} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Site ID 2</Table.Cell>
                  <Table.Cell> {sitevodafone!.siteID_c2} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Latitude</Table.Cell>
                  <Table.Cell> {sitevodafone!.latitude} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Longitude</Table.Cell>
                  <Table.Cell> {sitevodafone!.longitude} </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell >Remark</Table.Cell>
                  <Table.Cell> {sitevodafone!.remark} </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </Card.Content>
      <Card.Content extra>
        <Button.Group widths={2}>
          <Button
            as={Link} to={`/projectmanagement/sitevodafone-edit/${sitevodafone.id}`}
            basic
            color='blue'
            content='Edit'
          />
          <Button
            onClick={() => history.push('/projectmanagement/sitevodafone')}
            basic
            color='grey'
            content='Cancel'
          />
        </Button.Group>
      </Card.Content>
    </Card>
  );
};

export default observer(SiteVodafoneDetails);
